import { Component } from '@angular/core';
import { versions } from 'src/app/versions';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false
})
export class FooterComponent {
  readonly versions = versions;
  readonly year = new Date().getFullYear();
}
